import React, { Component } from "react";
import { Form, Modal } from "reactstrap";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Cargando from '../../../components/Generales/ModalCargando';
import GridItem from "components/Grid/GridItem.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import Globales from "utils/Globales";
import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from '@material-ui/core/FormControl';
import { Save, Clear, RefreshTwoTone } from "@material-ui/icons";

const idVacio = { _increment: "0", _machine: "0", _pid: "0", _timestamp: "0" };

class ModalSubirNivelGrupo extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      MostrarModal: false,
      _id: '',
      GrupoSeleccionado: {},
      ListaNiveles: [],
      NivelAnterior: {},
      idNivelAnterior: { _increment: '0', _machine: '0', _pid: '0', _timestamp: '0' },
      NivelSiguiente: {},
      NivelesAnteriores: [],
      LibrosGrupo: null,
      disabled: false,
      colorNotificacion: "warning",
      mensaje: "¿Está seguro que desea cambiar el nivel del grupo?",
      br: false,
      DesactivarBoton: false,
      NombreGuardado: '',
      SubcategoriaHabilitada: false,
      aviso: "",
      CuerpoCargando: "Cargando",
      show: false

    }
    this.handleChange = this.handleChange.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      this.props.eventClick();
    }
  }

  componentDidMount() {
    //console.log("GrupoSeleccionado", this.props.GrupoSeleccionado)
    let nivelesAnteriores = this.props.GrupoSeleccionado.NivelesAnteriores
      ? [].concat(this.props.GrupoSeleccionado.NivelesAnteriores.ObjectId)
      : [];

    let grupo = {
      ActaCerradaMaestro: this.props.GrupoSeleccionado.ActaCerradaMaestro,
      Activo: true,
      CapacidadAula: this.props.GrupoSeleccionado.CapacidadAula,
      Clase: this.props.GrupoSeleccionado.Clase,
      Clave: this.props.GrupoSeleccionado.Clave,
      Concluido: this.props.GrupoSeleccionado.Concluido,
      FechaIncioCurso: this.props.GrupoSeleccionado.FechaIncioCurso,
      Horario: this.props.GrupoSeleccionado.Horario,
      HorarioGrupo: this.props.GrupoSeleccionado.HorarioGrupo,
      IdGrupoAnterior: this.props.GrupoSeleccionado.IdGrupoAnterior,
      IdGrupoSiguiente: this.props.GrupoSeleccionado.IdGrupoSiguiente,
      IdLibro: this.props.GrupoSeleccionado.IdLibro,
      IdUnidadActual: this.props.GrupoSeleccionado.IdUnidadActual,
      ListaNiveles: !this.props.GrupoSeleccionado.ListaNiveles ? null : this.props.GrupoSeleccionado.ListaNiveles,
      Modalidad: this.props.GrupoSeleccionado.Modalidad,
      NivelesAnteriores: { ObjectId: [] },
      Nombre: this.props.GrupoSeleccionado.Nombre,
      TotalHorasSemana: this.props.GrupoSeleccionado.TotalHorasSemana,
      _id: this.props.GrupoSeleccionado._id,
      _idAula: this.props.GrupoSeleccionado._idAula,
      _idIdioma: this.props.GrupoSeleccionado._idIdioma,
      _idMaestro: this.props.GrupoSeleccionado._idMaestro,
      _idNivel: this.props.GrupoSeleccionado._idNivel,
    }

    this.setState({ GrupoSeleccionado: grupo, NivelesAnteriores: nivelesAnteriores, idNivelAnterior: this.props.GrupoSeleccionado._idNivel });
    this.ObtenerSiguienteNivel(this.props.GrupoSeleccionado);
    this.ObtenerInformacionGrupo(this.props.GrupoSeleccionado._id)
  }

  async ObtenerInformacionGrupo(idGrupo) {
    this.setState({ cargando: true });

    try {
      const res = await fetch(Globales.Url + 'Calificaciones/Calificaciones/ObtenerInformacionGrupo', {
        method: 'POST',
        headers: {
          Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
        },
        body: JSON.stringify({ idGrupo: idGrupo })
      });
      const respuesta = await res.json();

      if (respuesta.error) {
        this.setState({ mensaje: respuesta.mensaje, colorNotificacion: "danger", cargando: false });
        this.showNotification();
      } else {
        this.setState({ LibrosGrupo: respuesta.InfoGrupo.Libros, cargando: false });
      }
    } catch (err) {
      console.log(err)
      this.setState({ mensaje: "Ocurrió un error inesperado, por favor inténtelo de nuevo", colorNotificacion: "danger", br: true, CuerpoCargando: "Error", cargando: true })
    }
  }

  async ObtenerSiguienteNivel(grupo) {
    const idNivelValido = grupo._idNivel || idVacio;
    const nivelAnterior = { _id: idNivelValido };
    this.setState({ cargando: true, NivelAnterior: nivelAnterior });

    try {
      const res = await fetch(Globales.Url + 'Catalogos/Niveles/ObtenerSiguienteNivel', {
        method: 'POST',
        headers: {
          Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
        }, body: JSON.stringify({ IdNivelActual: grupo._idNivel, })
      });
      const respuesta = await res.json();
      console.log(respuesta);

      if (respuesta.error) {
        // this.setState({ mensaje: respuesta.mensaje, colorNotificacion: "danger", Activo: 1, cargando: false });
        // this.showNotification();
        this.setState({ cargando: false });
        this.cambiarSeleccionarNivel();
      } else {
        let nivelSiguiente = respuesta.data
        if (nivelSiguiente) {
          this.setState({
            mensaje: "",
            NivelSiguiente: nivelSiguiente,
            cargando: false
          });
        }
        else {
          this.setState({ mensaje: "No se puede subir de nivel a este grupo. No existe un nivel sucesor al nivel actual o este nivel no está marcado como último nivel.", colorNotificacion: "danger", disabled: true, cargando: false });
        }
      }
    } catch (err) {
      console.log(err)
      this.setState({ mensaje: "Ocurrió un error inesperado, por favor inténtelo de nuevo", colorNotificacion: "danger", br: true, CuerpoCargando: "Error", cargando: true })
    }
  }

  async ListarNiveles() {
    this.setState({ cargando: true, ListaNiveles: [], });

    try {
      const res = await fetch(Globales.Url + 'Idiomas/Idiomas/ListaNivelesIdioma', {
        method: 'POST',
        headers: {
          Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
        }, body: JSON.stringify({ idIdioma: this.props.GrupoSeleccionado._idIdioma, })
      });
      const respuesta = await res.json();
      console.log(respuesta);

      if (respuesta.error) {
        this.setState({ mensaje: respuesta.mensaje, colorNotificacion: "danger", Activo: 1, cargando: false });
        this.showNotification();
      } else {
        const niveles = [].concat(respuesta.data || []).filter(Boolean);
        this.setState({
          cargando: false,
          ListaNiveles: niveles,
        });
      }
    } catch (err) {
      console.log(err)
      this.setState({ mensaje: "Ocurrió un error inesperado, por favor inténtelo de nuevo", colorNotificacion: "danger", br: true, CuerpoCargando: "Error", cargando: true })
    }
  }

  CambiarNivel() {
  // 1. Clonar el objeto del grupo para evitar mutación directa
  let grupo = { ...this.state.GrupoSeleccionado };

  // 2. Crear objeto de nivel anterior
  var nivelAnterior = {
    FechaInicio: this.props.GrupoSeleccionado.FechaIncioCurso,
    FechaTermino: new Date(),
    HorarioGrupo: this.props.GrupoSeleccionado.HorarioGrupo,
    Libros: this.state.LibrosGrupo || [],
    TotalAlumnos: 0,
    _id: idVacio,
    idAula: grupo._idAula,
    idGrupo: grupo._id,
    idMaestro: grupo._idMaestro,
    idNivel: this.state.idNivelAnterior,
  };

  // 3. Manejo de ListaNiveles
  if (!grupo.ListaNiveles || !grupo.ListaNiveles.NivelGrupo) {
    grupo.ListaNiveles = {
      NivelGrupo: [nivelAnterior]
    };
  } else {
    const niveles = Array.isArray(grupo.ListaNiveles.NivelGrupo)
      ? grupo.ListaNiveles.NivelGrupo
      : [grupo.ListaNiveles.NivelGrupo];

    grupo.ListaNiveles = {
      NivelGrupo: [...niveles, nivelAnterior]
    };
  }

  // 4. Copiar y actualizar la lista de IDs de niveles anteriores limpiando valores nulos
  const nuevosNivelesAnteriores = [
    ...(this.state.NivelesAnteriores || []),
    this.state.idNivelAnterior,
  ].filter(Boolean);

    // Si el backend espera una lista de IDs limpia:
    grupo.NivelesAnteriores = { ObjectId: nuevosNivelesAnteriores };
  // *NOTA*: Si tu WCF exige explícitamente la envoltura BSON, verifica si debe ser:
  // grupo.NivelesAnteriores = { string: nuevosNivelesAnteriores };

  // 5. Actualizar propiedades del grupo actual
  grupo.FechaIncioCurso = new Date();
  grupo.IdUnidadActual = idVacio;
  grupo.IdLibro = idVacio;
  grupo.Nombre = "";
  grupo._idNivel = this.state.NivelSiguiente._id;

  // 6. Actualizar el estado si es necesario y enviar
  this.setState({ NivelesAnteriores: nuevosNivelesAnteriores }, () => {
    this.RegistrarGrupo(grupo);
  });
}
  async RegistrarGrupo(grupo) {
    const idVacio = { _increment: "0", _machine: "0", _pid: "0", _timestamp: "0" };
    this.setState({ cargando: true });

    try {
      const res = await fetch(Globales.Url + 'Grupos/Grupos/SubirNivel', {
        method: 'POST',
        headers: {
          Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
        }, body: JSON.stringify({ grupo: grupo, maestroAnterior: JSON.stringify(grupo._idMaestro) !== JSON.stringify(idVacio) ? grupo._idMaestro : idVacio })
      });
      const respuesta = await res.json();

      if (respuesta.error) {
        this.setState({ mensaje: respuesta.mensaje, colorNotificacion: "danger", ListaLibros: [], cargando: false });
        this.showNotification();
      } else {
        this.ActualizarUnidadesGrupo(grupo)
      }
    } catch (err) {
      console.log(err)
      this.setState({ mensaje: "Ocurrió un error inesperado, por favor inténtelo de nuevo", colorNotificacion: "danger", br: true, CuerpoCargando: "Error", cargando: true })
    }
  }

  async ActualizarUnidadesGrupo(grupo) {
    this.setState({ cargando: true })

    try {
      const res = await fetch(Globales.Url + 'Grupos/Grupos/ActualizarUnidadesGrupo', {
        method: 'POST',
        headers: {
          Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
        }, body: JSON.stringify({ idGrupo: grupo._id, idNivel: grupo._idNivel })
      });
      const respuesta = await res.json();

      if (respuesta.error) {
        this.setState({ mensaje: respuesta.mensaje, colorNotificacion: "danger", ListaLibros: [], cargando: false });
        this.showNotification();
      } else {
        this.setState({ cargando: false })
        this.RegresarMensaje("Se cambio el nivel del grupo exitosamente")
      }
    } catch (err) {
      console.log(err)
      this.setState({ mensaje: "Ocurrió un error inesperado, por favor inténtelo de nuevo", colorNotificacion: "danger", br: true, CuerpoCargando: "Error", cargando: true })
    }
  }

  // Regresar datos hacia afuera del modal ***********************************************************************************************************
  RegresarMensaje(mensaje) {
    //this.setState({ op1: 1 });
    this.props.parentCallback(mensaje);
    this.props.eventClick("esc");
  }

  closeModal() {
    this.props.eventClick("esc");
  }

  showNotification() {
    var x = [];
    this.setState({ br: true });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function () {
        this.setState({ br: false });
        this.setState(x);
      }.bind(this),
      4000
    );
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  cerrarModal = () => {
    this.props.eventClick("esc")
  }

  cambiarSeleccionarNivel = () => {
    let activar = !this.state.SelectorNivel
    this.setState({ SelectorNivel: activar })

    if (activar) {
      this.ListarNiveles()
    }
  }

  render() {
    const { NivelSiguiente } = this.state

    let agregar;
    if (this.state.cargando) {
      agregar = (
        <Cargando
          Cuerpo={this.state.CuerpoCargando}
          show={this.state.cargando}
        />
      );
    }

    return (
      <div>
        <Modal size="md" className="static-modal" isOpen={this.props.showSubirNivelGrupo}
          backdrop={true} toggle={this.cerrarModal} >
          <Card>
            <CardHeader color={this.state.colorNotificacion}>{this.props.Titulo}</CardHeader>
            <CardBody>
              <GridItem xs={12} sm={12} md={12}>
                {this.state.mensaje != "" ? this.state.mensaje :
                  `Se cambiará el nivel del grupo a ${NivelSiguiente.Nombre} ¿Desea continuar?`
                }
              </GridItem>

              <GridItem xs={12} sm={12} md={12} hidden={!this.state.SelectorNivel}>
                <FormControl fullWidth size="small"  >
                  <Select
                    value={this.state.NivelSiguiente}
                    onChange={this.handleChange.bind(this)}
                    variant="outlined"
                    name="NivelSiguiente"
                  >
                    {this.state.ListaNiveles.length == 0 ? null :
                      this.state.ListaNiveles.map((nivel) =>
                        <MenuItem value={nivel} >{nivel.Nombre}</MenuItem>
                      )}
                  </Select>
                </FormControl>
              </GridItem>

              <GridItem xs={12} sm={12} md={12}>
                <Button color="danger" size='sm' className='pull-left mr-2 mt-3' round
                  onClick={() => this.props.eventClick("esc")}><Clear />Cancelar</Button>

                {!this.state.disabled && !this.state.SelectorNivel &&
                  <Button color="success" size='sm' className='pull-right mr-2 mt-3' round
                    onClick={() => this.CambiarNivel()}><Save />Guardar</Button>
                }

                <Button color="warning" size="sm" className="pull-right mr-2 mt-3" round
                  onClick={this.cambiarSeleccionarNivel} >
                  <RefreshTwoTone /> {this.state.SelectorNivel ? "Seleccionar" : "Seleccionar otro"}
                </Button>

              </GridItem>
            </CardBody>
          </Card>
        </Modal>


        <div id="">
          {agregar}
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
        </div>
      </div>
    );
  }
}

export default withStyles(basicsStyle)(ModalSubirNivelGrupo);